import React, { useState, useRef, useEffect } from "react";
import {
  Autocomplete,
  TextField,
  Box,
  InputAdornment,
  Typography,
  useMediaQuery,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { IMAGE_BASE_URL } from "../../config/constants";

const SearchWithDropdown = ({ onSelectItem, itemsList = [], setClearSearch }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const inputRef = useRef(null);
  const isMobile = useMediaQuery("(max-width:600px)"); // Detect mobile screen

  // Provide a function to clear search when closing the drawer
  useEffect(() => {
    if (setClearSearch) {
      setClearSearch(() => () => setSearchTerm(""));
    }
  }, [setClearSearch]);

  // Filter items based on search term
  const filteredItems = itemsList.filter((item) =>
    item.label?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        maxWidth: isMobile ? "100%" : "500px", // Full width on mobile
        minWidth: isMobile ? "90%" : "350px", // Prevent shrinking
      }}
    >
      <Autocomplete
        freeSolo
        fullWidth
        options={filteredItems}
        getOptionLabel={(option) => option.label || "No Label Available"}
        renderOption={(props, option) => (
          <Box
            component="li"
            {...props}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              padding: "10px",
              borderBottom: "1px solid #ddd",
              "&:hover": { backgroundColor: "#f5f5f5" },
            }}
          >
            <img
              src={option.image ? `${IMAGE_BASE_URL}${option.image}` : "/path-to-placeholder.png"}
              alt={option.label || "No Label Available"}
              style={{ width: "70px", objectFit: "contain", borderRadius: "8px" }}
            />
            <Box>
              <Typography fontWeight="bold" fontSize="14px">
                {option.label || "No Label Available"}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                ₹{option.sellingprice || "N/A"}
              </Typography>
            </Box>
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            inputRef={inputRef}
            placeholder="Search items"
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              backgroundColor: "white",
              borderRadius: "25px",
              boxShadow: "0px 4px 12px rgba(0, 128, 128, 0.2)", // Softer teal shadow
              fontSize: "16px", // Prevents zooming issue on iOS
              width: "100%", // Ensures width doesn't change on focus
              "& .MuiOutlinedInput-root": {
                height: "40px",
                fontSize: "16px",
                borderRadius: "25px",
                "& fieldset": { borderColor: "#008080" },
                "&:hover fieldset": { borderColor: "#007070" },
                "&.Mui-focused fieldset": { borderColor: "#005050" },
              },
            }}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#008080" }} />
                </InputAdornment>
              ),
            }}
          />
        )}
        onChange={(e, value) => value && onSelectItem(value)}
      />
    </Box>
  );
};

export default SearchWithDropdown;
